import * as configureSolarApi from '../store/configureSolarApi';
import * as requestTypes from '../store/requestTypes';

const stromReducer = (state = {
    MixedBarDiagrammStromverbrauchUI: [],
    ...configureSolarApi.initialState
}, action) => {
    switch (action.type) {
        case "RECEIVE_MixDiagrammStromverbrauchClass_stromReducer":
            return { ...state, MixedBarDiagrammStromverbrauchUI: action.value, isLoaded: true };
        // Bei forceRefresh: Alte Daten sofort leeren damit Chart Skeleton zeigt!
        case requestTypes.requestStartType.type:
            return { ...state, MixedBarDiagrammStromverbrauchUI: [], isLoaded: false };
    }

    return configureSolarApi.switchCaseForDefaultActionTypesForReducers(action, state);
};
export default stromReducer;
